import type {
  CameraPosition,
  DeviceFilter,
} from '@/react-native-vision-camera';

export const CAMERA_FILTER: DeviceFilter = {
  physicalDevices: [
    'ultra-wide-angle-camera',
    'wide-angle-camera',
    'telephoto-camera',
  ],
};

export const CAMERA_POSITION: CameraPosition = 'back';
